<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">

        <projectMenu :project="project" :boardId="boardId"></projectMenu>

        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>

          <div class="card-body">
            <div class="row mt-5">
              <div class="col-sm-12">
                <h4>Płatności</h4>
                <div class="loader-box-risk d-none"
                     style="position:absolute; height: 100%; width: 100%; z-index: 99; text-align: center; background-color: rgba(255,255,255,.7); display: flex;justify-content: center;align-items: center;">
                  <div class="loader"></div>
                  <div class="position-absolute" style="top:75%">Dodawanie nowego wiersza</div>
                </div>
                <table class="table table-bordered">
                  <tbody>
                  <tr>
                    <td></td>
                    <td class="text-center py-2"><b>KWOTA NETTO</b></td>
                    <td class="text-center py-2"><b>KWOTA BRUTTO</b></td>
                    <td colspan="text-center py-2">VAT</td>
                    <td colspan="7"></td>
                  </tr>
                  <tr>
                    <td class="ps-2">Wartość projektu</td>
                    <td class="text-center">
                      <vue-numeric
                          v-model.number="offerPriceNet"
                          :currency="offerCurrency"
                          currency-symbol-position="suffix"
                          separator=" "
                          thousand-separator=" "
                          :precision="2"
                          v-bind:minus="false"
                          @input="startEditingPrice();updateGrossFromNet()"
                          class="form-control form-control-sm text-center d-inline-flex w-auto"
                      />
                    </td>
                    <td class="text-center">
                      <vue-numeric
                          v-model.number="offerPriceGross"
                          :currency="offerCurrency"
                          currency-symbol-position="suffix"
                          separator=" "
                          thousand-separator=" "
                          :precision="2"
                          v-bind:minus="false"
                          @input="startEditingPrice();updateNetFromGross()"
                          class="form-control form-control-sm text-center d-inline-flex w-auto"
                      />
                    </td>
                    <td class="position-relative">
                      <select class="form-select form-select-sm"
                              @change="onVatChange" v-model="paymentVat">
                        <option value="0">0%</option>
                        <option value="8">8%</option>
                        <option value="20">20%</option>
                        <option value="23">23%</option>
                      </select>
                    </td>
                    <td>
                      <div v-if="editingPrice" class="d-flex gap-2">
                        <button class="btn btn-sm btn-success" @click="confirmPriceEdit">Zapisz</button>
                        <button class="btn btn-sm btn-outline-secondary" @click="cancelPriceEdit">Anuluj</button>
                      </div>
                    </td>
                    <td colspan="6"></td>
                  </tr>

                  <tr>
                    <td :rowspan="editPayments.length <= 0 ? 2 : editPayments.length+2" class="ps-2">Płatności</td>
                    <td colspan="2" class="text-center pt-3 pb-3">Warunki płatności</td>
                    <td class="text-center">Kwota zapłaty netto</td>
                    <td class="text-center">Kwota zapłaty brutto</td>
                    <td class="text-center">Waluta</td>
                    <td class="text-center">Kurs</td>
                    <td class="text-center">Numer faktury</td>
                    <td class="text-center">Data zapłaty</td>
                    <td></td>
                  </tr>
                  <tr class="text-center" v-for="payment in editPayments">
                    <td @dblclick="editingPaymentTerms1(payment)">
                      <div v-if="isEditingTerms1[payment.id]">
                        <input type="text" v-model="payment.payment_terms1" class="form-control form-control-sm">
                      </div>
                      <div v-else>
                        {{ payment.payment_terms1 }}
                      </div>
                    </td>
                    <td @dblclick="editingPaymentTerms2(payment)">
                      <div v-if="isEditingTerms2[payment.id]">
                        <input type="text" v-model="payment.payment_terms2" class="form-control form-control-sm">
                      </div>
                      <div v-else>
                        {{ payment.payment_terms2 }}
                      </div>
                    </td>
                    <td>
                      <vue-numeric
                          :model-value="toNum(payment.net_payment_amount)"
                          @update:modelValue="val => {
                            payment.net_payment_amount = toNum(val);
                            changeGrossPayment(payment.id, 'net_payment_amount');
                          }"
                          :key="payment.id"
                          separator=" "
                          thousand-separator=" "
                          :precision="2"
                          :minus="false"
                          class="form-control form-control-sm text-center"
                      />
                    </td>

                    <td>
                      <vue-numeric
                          :model-value="toNum(payment.gross_payment_amount)"
                          @update:modelValue="val => {
                              payment.gross_payment_amount = toNum(val);
                              changeGrossPayment(payment.id, 'gross_payment_amount');
                          }"
                          :key="payment.id"
                          separator=" "
                          thousand-separator=" "
                          :precision="2"
                          :minus="false"
                          class="form-control form-control-sm text-center"
                      />
                    </td>

                    <td>
                      <select @change="changeGrossPayment(payment.id, 'currency')"
                              class="form-select form-select-sm" v-model="payment.currency"
                              :key="payment.id">
                        <option value="PLN" :selected="payment.currency === 'PLN'">PLN</option>
                        <option value="EUR" :selected="payment.currency === 'EUR'">EUR</option>
                        <option value="USD" :selected="payment.currency === 'USD'">USD</option>
                      </select>
                    </td>
                    <td>
                      <input @change="changeGrossPayment(payment.id, 'exchange_rate')"
                             class="form-control form-control-sm text-center" type="number" step="0.01" min="1"
                             :key="payment.id" v-model="payment.exchange_rate">
                    </td>
                    <td>
                      <input @change="changeGrossPayment(payment.id, 'invoice_number')"
                             class="form-control form-control-sm text-center" type="text" :key="payment.id"
                             v-model="payment.invoice_number">
                    </td>
                    <td>
                      <input @change="changeGrossPayment(payment.id, 'payment_date')"
                             class="form-control form-control-sm text-center" type="date" :key="payment.id"
                             v-model="payment.payment_date">
                    </td>
                    <td>
                      <button @click="removePayment(payment)">
                        <i class="bi bi-trash text-danger"></i>
                      </button>
                    </td>
                    <td class="text-center align-middle">
                                            <span v-for="changes in paymentChanged" class="p-0">
                                                <button v-if="changes === payment.id" @click="updatePayment(payment.id)"
                                                        type="button" class="btn btn-sm btn-primary">Aktualizuj</button>
                                            </span>
                    </td>
                  </tr>
                  <tr>
                    <td v-if="creatingPaymentTerms">
                      <input type="text" class="form-control form-control-sm btn-outline-warning"
                             v-model="newPaymentTerm.term1">
                    </td>
                    <td v-if="creatingPaymentTerms">
                      <input type="text" class="form-control form-control-sm btn-outline-warning"
                             v-model="newPaymentTerm.term2">
                    </td>

                    <td :colspan="creatingPaymentTerms === true ? 1 : 8" class="text-end">
                      <button class="btn btn-sm btn-primary me-2 py-1" v-if="creatingPaymentTerms"
                              @click="storePaymentTerm()">
                        <i class="bi bi-download"></i>&nbsp;Zapisz
                      </button>
                      <button class="btn btn-sm btn-outline-primary p-1" @click="createPaymentTerm()">
                        <i class="bi bi-plus-circle"></i>&nbsp;
                        <span v-if="creatingPaymentTerms">anuluj </span>
                        <span v-if="!creatingPaymentTerms">dodaj </span>
                        &nbsp;warunki
                      </button>
                    </td>
                  </tr>
                  <tr style="font-weight: 600;">
                    <td class="ps-2 pt-3 pb-3" colspan="2">Pozostaje do zapłaty Netto</td>
                    <td class="text-end">
                                            <span
                                                :class="
                                        {'text-warning':(offerPriceNet - alreadyPaid.net.toFixed(2)) < 0,
                                         'text-success':(offerPriceNet - alreadyPaid.net.toFixed(2)) === 0}"
                                                v-if="offerPriceNet && alreadyPaid.net">
                                            {{ formatMoney(offerPriceNet - alreadyPaid.net) }} {{ offerCurrency }}
                                            </span> <span v-else>-</span>
                    </td>
                    <td colspan="8"></td>
                  </tr>
                  <tr style="font-weight: 600;">
                    <td class="ps-2 pt-3 pb-3" colspan="2">Pozostaje do zapłaty Brutto</td>
                    <td class="text-end">
                                            <span
                                                :class="
                                        {'text-warning':(offerPriceGross - alreadyPaid.gross.toFixed(2)) < 0,
                                         'text-success':(offerPriceGross - alreadyPaid.gross.toFixed(2)) === 0}"
                                                v-if="offerPriceNet && offerPriceGross && alreadyPaid.gross">
                                            {{ formatMoney(offerPriceGross - alreadyPaid.gross) }} {{ offerCurrency }}
                                            </span> <span v-else>-</span>
                    </td>
                    <td colspan="8"></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <!-- CUSTOMOWE PŁATNOŚCI -->
              <div class="col-sm-12" v-for="(customPayment, idx) in localCustomPayments"
                   :key="customPayment.id ?? ('new-'+idx)">

                <div class="mt-5 mb-2">
                  <div class="d-flex justify-content-between w-100">
                    <h5 class="d-flex align-items-center"><span class="me-2 w-100">#{{ idx + 1 }} Niestandardowa płatność:</span>
                      <input type="text" class="form-control form-control-sm w-50" v-model="customPayment.order_no"
                             @input="startEditingCustomPrice(idx)"
                             placeholder="Nr zamówienia">
                    </h5>
                    <button type="button" class="d-flex btn btn-sm btn-outline-danger ms-auto"
                            @click="deleteCustomPayment(customPayment)">
                      <i class="bi bi-trash"></i> Usuń płatność
                    </button>
                  </div>
                </div>


                <table class="table table-bordered">
                  <tbody>
                  <tr>
                    <td></td>
                    <td class="text-center py-2"><b>KWOTA NETTO</b></td>
                    <td class="text-center py-2"><b>KWOTA BRUTTO</b></td>
                    <td colspan="text-center py-2">VAT</td>
                    <td colspan="text-center py-2">WALUTA</td>
                    <td colspan="6"></td>
                  </tr>
                  <tr>
                    <td class="ps-2">Wartość</td>
                    <td class="text-center">
                      <vue-numeric
                          v-model.number="customPayment.price_net"
                          :currency="customPayment.currency"
                          currency-symbol-position="suffix"
                          separator=" "
                          thousand-separator=" "
                          :precision="2"
                          v-bind:minus="false"
                          @input="startEditingCustomPrice(idx);updateGrossFromNetCustom(idx)"
                          class="form-control form-control-sm text-center d-inline-flex w-auto"
                      />
                    </td>
                    <td class="text-center">
                      <vue-numeric
                          v-model.number="customPayment.price_gross"
                          :currency="customPayment.currency"
                          currency-symbol-position="suffix"
                          separator=" "
                          thousand-separator=" "
                          :precision="2"
                          v-bind:minus="false"
                          @input="startEditingCustomPrice(idx);updateNetFromGrossCustom(idx)"
                          class="form-control form-control-sm text-center d-inline-flex w-auto"
                      />
                    </td>
                    <td class="position-relative">
                      <select class="form-select form-select-sm"
                              @change="onVatChangeCustom(idx)" v-model.number="customPayment.vat">
                        <option value="0">0%</option>
                        <option value="8">8%</option>
                        <option value="20">20%</option>
                        <option value="23">23%</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-select form-select-sm"
                              @change="onCurrencyChangeCustom(idx)" v-model="customPayment.currency">
                        <option value="PLN">PLN</option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                      </select>
                    </td>
                    <td>
                      <div v-if="customPayment.editingPrice" class="d-flex gap-2">
                        <button class="btn btn-sm btn-success" @click="confirmPriceEditCustom(idx)">Zapisz</button>
                        <button class="btn btn-sm btn-outline-secondary" @click="cancelPriceEditCustom(idx)">Anuluj
                        </button>
                      </div>
                    </td>
                    <td colspan="6"></td>
                  </tr>

                  <!-- Mini-tabela płatności wewnątrz customPayment -->
                  <tr>
                    <td :rowspan="customPayment.terms.length <= 0 ? 2 : customPayment.terms.length+2"
                        class="ps-2">Płatności
                    </td>
                    <td colspan="2" class="text-center pt-3 pb-3">Warunki płatności</td>
                    <td class="text-center">Kwota zapłaty netto</td>
                    <td class="text-center">Kwota zapłaty brutto</td>
                    <td class="text-center">Waluta</td>
                    <td class="text-center">Kurs</td>
                    <td class="text-center">Numer faktury</td>
                    <td class="text-center">Data zapłaty</td>
                    <td></td>
                  </tr>
                  <tr class="text-center" v-for="payment in customPayment.terms">
                    <td @dblclick="editingCustomPaymentTerms1(payment, idx)">
                      <div v-if="customPayment.isEditingTerms1 && customPayment.isEditingTerms1[payment.id]">
                        <input type="text" v-model="payment.payment_terms1" class="form-control form-control-sm">
                      </div>
                      <div v-else>
                        {{ payment.payment_terms1 }}
                      </div>
                    </td>
                    <td @dblclick="editingCustomPaymentTerms2(payment, idx)">
                      <div v-if="customPayment.isEditingTerms2 && customPayment.isEditingTerms2[payment.id]">
                        <input type="text" v-model="payment.payment_terms2" class="form-control form-control-sm">
                      </div>
                      <div v-else>
                        {{ payment.payment_terms2 }}
                      </div>
                    </td>
                    <td>
                      <vue-numeric
                          v-model="payment.net_payment_amount"
                          :key="payment.id"
                          separator=" "
                          thousand-separator=" "
                          :precision="2"
                          v-bind:minus="false"
                          @input="changeGrossPaymentCustom(payment.id, 'net_payment_amount', idx)"
                          class="form-control form-control-sm text-center"
                      />
                    </td>
                    <td>
                      <vue-numeric
                          v-model="payment.gross_payment_amount"
                          :key="payment.id"
                          separator=" "
                          thousand-separator=" "
                          :precision="2"
                          v-bind:minus="false"
                          @input="changeGrossPaymentCustom(payment.id, 'gross_payment_amount', idx)"
                          class="form-control form-control-sm text-center"
                      />
                    </td>
                    <td>
                      <select @change="changeGrossPaymentCustom(payment.id, 'currency', idx)"
                              class="form-select form-select-sm" v-model="payment.currency"
                              :key="payment.id">
                        <option value="PLN">PLN</option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                      </select>
                    </td>
                    <td>
                      <input @change="changeGrossPaymentCustom(payment.id, 'exchange_rate', idx)"
                             class="form-control form-control-sm text-center" type="number" step="0.01" min="1"
                             :key="payment.id" v-model="payment.exchange_rate">
                    </td>
                    <td>
                      <input @change="changeGrossPaymentCustom(payment.id, 'invoice_number', idx)"
                             class="form-control form-control-sm text-center" type="text" :key="payment.id"
                             v-model="payment.invoice_number">
                    </td>
                    <td>
                      <input @change="changeGrossPaymentCustom(payment.id, 'payment_date', idx)"
                             class="form-control form-control-sm text-center" type="date" :key="payment.id"
                             v-model="payment.payment_date">
                    </td>
                    <td>
                      <button @click="removeCustomPaymentTerm(payment, idx)">
                        <i class="bi bi-trash text-danger"></i>
                      </button>
                    </td>
                    <td class="text-center align-middle">
                      <button v-if="paymentChangedCustom[payment.id]"
                              @click="updateCustomPaymentTerms(payment.id, idx)"
                              type="button" class="btn btn-sm btn-primary">Aktualizuj
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td v-if="customPayment.creatingPaymentTerms">
                      <input type="text" class="form-control form-control-sm btn-outline-warning" required
                             v-model="customPayment.newPaymentTerm.term1">
                    </td>
                    <td v-if="customPayment.creatingPaymentTerms">
                      <input type="text" class="form-control form-control-sm btn-outline-warning" required
                             v-model="customPayment.newPaymentTerm.term2">
                    </td>

                    <td :colspan="customPayment.creatingPaymentTerms === true ? 1 : 8" class="text-end">
                      <button
                          type="button"
                          class="btn btn-sm btn-primary me-2 py-1"
                          v-if="customPayment.creatingPaymentTerms"
                          :disabled="customPayment._savingTerm === true"
                          @click.prevent.stop="storeCustomPaymentTerm(customPayment, idx)"
                      >
                        <i class="bi bi-download"></i>&nbsp;Zapisz
                      </button>
                      <button
                          v-if="customPayment.id"
                          type="button"
                          class="btn btn-sm btn-outline-primary p-1"
                          @click.prevent.stop="createCustomPaymentTerm(idx)"
                      >
                        <i class="bi bi-plus-circle"></i>&nbsp;
                        <span v-if="customPayment.creatingPaymentTerms">anuluj </span>
                        <span v-else>dodaj&nbsp;warunki</span>
                      </button>
                    </td>
                  </tr>
                  <tr style="font-weight: 600;">
                    <td class="ps-2 pt-3 pb-3" colspan="2">Pozostaje do zapłaty Netto</td>
                    <td class="text-end">
                      <span
                          :class="{
                            'text-warning': (customPayment.price_net - (customPayment.alreadyPaid?.net || 0)) < 0,
                            'text-success': (customPayment.price_net - (customPayment.alreadyPaid?.net || 0)) === 0
                          }"
                          v-if="customPayment.price_net && customPayment.alreadyPaid?.net">
                        {{ formatMoney(customPayment.price_net - customPayment.alreadyPaid.net) }} {{ offerCurrency }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td colspan="8"></td>
                  </tr>
                  <tr style="font-weight: 600;">
                    <td class="ps-2 pt-3 pb-3" colspan="2">Pozostaje do zapłaty Brutto</td>
                    <td class="text-end">
                      <span
                          :class="{
                            'text-warning': (customPayment.price_gross - (customPayment.alreadyPaid?.gross || 0)) < 0,
                            'text-success': (customPayment.price_gross - (customPayment.alreadyPaid?.gross || 0)) === 0
                          }"
                          v-if="customPayment.price_gross && customPayment.alreadyPaid?.gross">
                        {{ formatMoney(customPayment.price_gross - customPayment.alreadyPaid.gross) }} {{
                          offerCurrency
                        }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td colspan="8"></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <!-- PRZYCISK DODAJĄCY NOWĄ CUSTOMOWĄ PŁATNOŚĆ -->
              <div class="col-sm-12">
                <button type="button" class="btn btn-sm btn-outline-primary"
                        @click="addCustomPayment"><i class="bi bi-plus-circle me-1"></i>dodaj
                  niestandardową płatność
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import projectMenu from "@/Pages/Projects/parts/projectMenu.vue";
import VueNumeric from '@handcrafted-market/vue3-numeric'

export default {
  components: {AppLayout, projectMenu, VueNumeric},
  props: {
    project: Object,
    payments: Object,
    boardId: Number,
    customPayments: Object,
    offerVersion: Object
  },

  data() {
    const firstPayment = this.payments?.[0] ?? null;
    return {
      vatIsUpdating: false,
      editPayments: this.payments,
      netProjectValue: 0,
      grossProjectValue: 0,
      creatingPaymentTerms: false,
      paymentChanged: [],
      newPaymentTerm: {
        term1: '',
        term2: ''
      },
      offerPriceNet: parseFloat(firstPayment?.price_net) || parseFloat(this.offerVersion?.price) || 0,
      paymentVat: firstPayment?.vat ?? 0,
      offerPriceGross: parseFloat(firstPayment?.price_gross)
          || parseFloat((parseFloat(firstPayment?.price_net || this.offerVersion?.price || 0)) * (1 + (firstPayment?.vat ?? 0) / 100)),
      offerCurrency: this.offerVersion.currency || "PLN",
      alreadyPaid: {net: 0, gross: 0},
      isEditingTerms1: {},
      isEditingTerms2: {},

      editingPrice: false,
      originalVat: null,
      originalPriceNet: null,
      originalPriceGross: null,
      localCustomPayments: [],
      paymentChangedCustom: {}
    }
  },

  mounted() {
    this.originalVat = this.paymentVat;
    this.originalPriceNet = this.offerPriceNet;
    this.originalPriceGross = this.offerPriceGross;

    this.getPaidSum();
  },

  watch: {
    customPayments: {
      handler(newVal) {
        this.localCustomPayments = (newVal || []).map(cp => ({
          ...cp,
          vat: Number(cp.vat ?? 0),
          currency: (cp.currency || this.offerCurrency || 'PLN').toUpperCase(),
          terms: cp.terms || [],
          isEditingTerms1: {},
          isEditingTerms2: {},
          creatingPaymentTerms: false,
          newPaymentTerm: {term1: '', term2: ''},
          alreadyPaid: cp.alreadyPaid || {net: 0, gross: 0},
          editingPrice: false,
        }));
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    route,
    isRouteActive(routeName) {
      return route().current() === routeName;
    },

    startEditingPrice() {
      this.editingPrice = true;
    },

    cancelPriceEdit() {
      this.offerPriceNet = this.originalPriceNet;
      this.offerPriceGross = this.originalPriceGross;
      this.paymentVat = this.originalVat;
      this.editingPrice = false;
      this.getPaidSum();
    },

    onVatChange() {
      this.startEditingPrice();

      if (this.offerPriceNet) {
        this.offerPriceGross = parseFloat((this.offerPriceNet * (1 + this.paymentVat / 100)).toFixed(2));
      }
    },

    confirmPriceEdit() {
      this.originalPriceNet = this.offerPriceNet;
      this.originalPriceGross = this.offerPriceGross;
      this.originalVat = this.paymentVat;

      // przeliczenie brutto od nowa
      this.offerPriceGross = this.offerPriceNet + (this.offerPriceNet * this.paymentVat / 100);
      this.editingPrice = false;
      this.getPaidSum();

      this.updateProjectPricesAndVat();
    },

    updateGrossFromNet() {
      if (this.paymentVat !== null && this.paymentVat !== undefined) {
        this.offerPriceGross = parseFloat((this.offerPriceNet * (1 + this.paymentVat / 100)).toFixed(2));
      }
    },

    updateNetFromGross() {
      if (this.paymentVat !== null && this.paymentVat !== undefined) {
        this.offerPriceNet = parseFloat((this.offerPriceGross / (1 + this.paymentVat / 100)).toFixed(2));
      }
    },

    createPaymentTerm() {
      this.creatingPaymentTerms = this.creatingPaymentTerms !== true;
    },

    storePaymentTerm() {
      const self = this;

      axios.post(route('projects.show.payments.storePaymentTerm', self.project.id), {
        'payment_terms1': self.newPaymentTerm.term1,
        'payment_terms2': self.newPaymentTerm.term2
      }).then(response => {
        self.newPaymentTerm.term1 = '';
        self.newPaymentTerm.term2 = '';

        self.editPayments = response.data.payments;
        this.creatingPaymentTerms = false;

        Toast.fire({
          toast: true,
          icon: response.data.icon,
          title: response.data.title,
          html: response.data.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        })
      }).catch(error => {
        console.log(error);
        Toast.fire({
          toast: true,
          icon: 'error',
          title: 'Błąd',
          html: error.response.data.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        })
        console.log(error);
      })
    },

    updatePayment(paymentId) {
      const self = this;
      let payment = this.editPayments.find(payment => payment.id === paymentId);

      axios.post(route('projects.show.payments.updatePayment', paymentId), {
        'payment': payment,
      }).then(response => {

        if (response.data.payments) {
          // usuń kwoty do zmiany z paymentChanged
          let toRemove = self.paymentChanged.indexOf(paymentId);
          if (toRemove !== -1) {
            self.paymentChanged.splice(toRemove, 1);
          }

          // usuń warunki płatności z paymentChanged
          delete self.isEditingTerms1[paymentId];
          delete self.isEditingTerms2[paymentId];
        }
        if (self.paymentChanged.length === 0) {
          self.editPayments = response.data.payments;
        }

        self.getPaidSum(); // zaktualizuj pozostałe do zapłaty

        Toast.fire({
          toast: true,
          icon: response.data.icon,
          title: response.data.title,
          html: response.data.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        })
      }).catch(error => {
        console.log(error);
        Toast.fire({
          toast: true,
          icon: 'error',
          title: 'Błąd',
          html: error.response.data.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        })
        console.log(error);
      })
    },

    editingPaymentTerms1(payment, index = null) {
      if (!index) {
        this.isEditingTerms1[payment.id] = true;
        this.changeGrossPayment(payment.id, 'payment_terms1');
      }
    },

    editingPaymentTerms2(payment, index = null) {
      if (!index) {
        this.isEditingTerms2[payment.id] = true;
        this.changeGrossPayment(payment.id, 'payment_terms2');
      }
    },

    onCurrencyChangeCustom(idx) {
      // przy zmianie waluty
      this.startEditingCustomPrice(idx);
    },

    removePayment(payment) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie płatności',
        html: 'Jesteś pewny że chcesz usunąć płatność?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        denyButtonText: 'Nie',
        confirmButtonText: 'Tak',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(route('projects.show.payments.destroyPayment', this.project.id), {
            payment: payment
          }).then(response => {
            this.editPayments = response.data.payments;
            this.getPaidSum();
            Toast.fire({
              toast: true,
              icon: response.data.icon,
              title: response.data.title,
              html: response.data.message,
              showClass: {popup: 'animate__animated animate__fadeInDown'},
              hideClass: {popup: 'animate__animated animate__fadeOutUp'},
              timer: 2500,
            })
          }).catch(error => {
            console.log(error);
            Toast.fire({
              toast: true,
              icon: 'error',
              title: 'Błąd',
              html: error.response.data.message,
              showClass: {popup: 'animate__animated animate__fadeInDown'},
              hideClass: {popup: 'animate__animated animate__fadeOutUp'},
              timer: 2500,
            })
            console.log(error);
          })
        }
      });
    },

    changeGrossPayment(id, item) {
      if (!this.paymentChanged.includes(id)) {
        this.paymentChanged.push(id);
      }

      // jeśli zmienia się kwota zapłaty netto pozycji
      if (item === 'net_payment_amount') {
        let net = this.editPayments.find(payment => payment.id === id).net_payment_amount;
        let exchangeRate = this.editPayments.find(payment => payment.id === id).exchange_rate;
        this.editPayments.find(payment => payment.id === id).gross_payment_amount = parseFloat((net * exchangeRate + (net * (this.paymentVat / 100))).toFixed(2));

      } else if (item === 'vat') {
        let newVat = id;
        // zmień vat dla wszystkich pozycji płatności
        // oraz przelicz brutto dla nich
        this.editPayments.forEach(function (row, val) {
          let net = row.net_payment_amount;
          row.vat = newVat;
          row.gross_payment_amount = parseFloat((net + (net * (newVat / 100))).toFixed(2));
        })


        // oblicz brutto dla wartości projektu
        this.offerPriceGross = this.offerPriceNet + (this.offerPriceNet * (newVat / 100));
      }

      this.getPaidSum();
    },

    updateProjectPricesAndVat() {
      // zapisz nowy vat w bazie
      this.vatIsUpdating = true;
      axios.post(route('projects.show.payments.updatePricesAndVatPayment', {project: this.project}), {
        vat: this.paymentVat,
        priceNet: this.offerPriceNet,
        priceGross: this.offerPriceGross
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.vatIsUpdating = false;
      })
    },


    getPaidSum() {
      let payments = this.editPayments;
      const baseCurrency = this.offerCurrency;
      let paidNet = 0;
      let paidGross = 0;
      let vat = this.paymentVat;

      // Oblicz brutto dla wartości projektu
      this.offerPriceGross = this.offerPriceNet + (this.offerPriceNet * (vat / 100));

      // Oblicz ile projektu zostało opłacone
      payments.forEach(payment => {
        const net = parseFloat(payment.net_payment_amount) || 0;
        const gross = parseFloat(payment.gross_payment_amount) || 0;
        const exchangeRate = parseFloat(payment.exchange_rate) || 1;
        const paymentCurrency = payment.currency;

        const rate = paymentCurrency !== baseCurrency ? exchangeRate : 1;

        paidNet += net * rate;
        paidGross += gross * rate;
      });

      this.alreadyPaid.net = paidNet;
      this.alreadyPaid.gross = paidGross;
    },


    // CUSTOM PAYMENTS

    // Dodanie nowej customowej płatności (osobna tabela)
    addCustomPayment() {
      this.localCustomPayments.push({
        order_no: '',
        price_net: 0,
        price_gross: 0,
        vat: 23,
        currency: (this.offerCurrency || 'PLN').toUpperCase(),
        editingPrice: false,
        alreadyPaid: {net: 0, gross: 0},
        terms: [],
        isEditingTerms1: {},
        isEditingTerms2: {},
        creatingPaymentTerms: false,
        newPaymentTerm: {term1: '', term2: ''},
      });
    },

    startEditingCustomPrice(idx) {
      this.localCustomPayments[idx].editingPrice = true;
    },
    cancelPriceEditCustom(idx) {
      this.localCustomPayments[idx].editingPrice = false;
      // Jeśli chcesz: przywróć stare wartości na podstawie backupu, np. localCustomPayments[idx].backup
    },
    confirmPriceEditCustom(idx) {
      const custom = this.localCustomPayments[idx];
      if (!custom.order_no || !String(custom.order_no).trim().length) {
        Toast.fire({
          toast: true,
          icon: 'warning',
          title: 'Brak numeru zamówienia',
          html: 'Podaj numer zamówienia przed zapisaniem płatności.',
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        });
        return;
      }

      // jak zwróci sukces to ukryj button zapisu
      this.updateCustomProjectPricesAndVat(idx, true, () => {
        custom.editingPrice = false;
      });

    },

    updateGrossFromNetCustom(idx) {
      const cp = this.localCustomPayments[idx];
      const vat = Number(cp.vat ?? 0);
      const net = Number(cp.price_net ?? 0);
      cp.price_gross = Number((net * (1 + vat / 100)).toFixed(2));
    },

    updateNetFromGrossCustom(idx) {
      const cp = this.localCustomPayments[idx];
      const vat = Number(cp.vat ?? 0);
      const gross = Number(cp.price_gross ?? 0);
      const denom = (1 + vat / 100) || 1;
      cp.price_net = Number((gross / denom).toFixed(2));
    },

    onVatChangeCustom(idx) {
      this.startEditingCustomPrice(idx);
      this.updateGrossFromNetCustom(idx);
    },

    deleteCustomPayment(customPayment) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie płatności',
        html: 'Jesteś pewny że chcesz usunąć płatność?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        denyButtonText: 'Nie',
        confirmButtonText: 'Tak',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(route('projects.show.custom-payments.destroyPayment', {customPayment: customPayment}))
              .then(response => {
                this.editPayments = response.data.payments;
                this.localCustomPayments = this.localCustomPayments.filter(payment => payment.order_no !== customPayment.order_no);
                this.getPaidSum();
                Toast.fire({
                  toast: true,
                  icon: response.data.icon,
                  title: response.data.title,
                  html: response.data.message,
                  showClass: {popup: 'animate__animated animate__fadeInDown'},
                  hideClass: {popup: 'animate__animated animate__fadeOutUp'},
                  timer: 2500,
                })
              }).catch(error => {
            console.log(error);
            Toast.fire({
              toast: true,
              icon: 'error',
              title: 'Błąd',
              html: error.response.data.message,
              showClass: {popup: 'animate__animated animate__fadeInDown'},
              hideClass: {popup: 'animate__animated animate__fadeOutUp'},
              timer: 2500,
            })
            console.log(error);
          })
        }
      });
    },

    storeCustomPaymentTerm(customPayment, idx) {

      // szybka walidacja czy termy zostały uzupełnione
      const term1 = (customPayment.newPaymentTerm.term1 || '').trim();
      const term2 = (customPayment.newPaymentTerm.term2 || '').trim();
      if (!term1 || !term2) {
        Toast.fire({toast: true, icon: 'error', title: 'Błąd', html: 'Uzupełnij pola warunków płatności'});
        return;
      }

      let custom = this.localCustomPayments[idx];
      custom.terms.push({
        id: customPayment.id,
        order_no: String(customPayment.order_no),
        payment_terms1: customPayment.newPaymentTerm.term1,
        payment_terms2: customPayment.newPaymentTerm.term2,
        net_payment_amount: 0,
        gross_payment_amount: 0,
        currency: 'PLN',
        exchange_rate: 1,
        invoice_number: '',
        payment_date: '',
      });

      axios.post(route('projects.show.custom-payments.storePaymentTerm', this.project.id), {
        'order_no': String(customPayment.order_no),
        'payment_terms1': customPayment.newPaymentTerm.term1,
        'payment_terms2': customPayment.newPaymentTerm.term2
      }).then(response => {

        custom.newPaymentTerm = {term1: '', term2: ''};
        custom.creatingPaymentTerms = false;

        Toast.fire({
          toast: true,
          icon: response.data.icon,
          title: response.data.title,
          html: response.data.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        })
      }).catch(error => {
        console.log(error);
        Toast.fire({
          toast: true,
          icon: 'error',
          title: 'Błąd',
          html: error.response.data.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        })
        console.log(error);
      })
    },

    updateCustomProjectPricesAndVat(idx, refresh = false) {
      const custom = this.localCustomPayments[idx];
      this.$set(custom, 'vatIsUpdating', true);

      axios.post(route('projects.show.custom-payments.updatePricesAndVatPayment', {
        project: this.project,
        custom_payment: custom.id
      }), {
        vat: custom.vat,
        priceNet: custom.price_net,
        priceGross: custom.price_gross,
        order_no: custom.order_no,
        currency: custom.currency,
      }).then(response => {
        Toast.fire({
          toast: true,
          icon: response.data.icon,
          title: response.data.title,
          html: response.data.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        });

        // odśwież customPayments, jeśli trzeba.
        if (refresh && response.data.customPayments) {
          this.localCustomPayments = (response.data.customPayments || []).map(cp => ({
            ...cp,
            terms: cp.terms || [],
            isEditingTerms1: {},
            isEditingTerms2: {},
            creatingPaymentTerms: false,
            newPaymentTerm: {term1: '', term2: ''},
            _savingTerm: false,
            alreadyPaid: cp.alreadyPaid || {net: 0, gross: 0},
            editingPrice: false,
          }));
        }
      }).catch(error => {
        console.log(error);
        Toast.fire({
          toast: true,
          icon: 'error',
          title: 'Błąd',
          html: error.response?.data?.error || error.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        });
      }).finally(() => {
        this.$set(custom, 'vatIsUpdating', false);
      });
    },


    // Warunki płatności – pole 1 i 2
    editingCustomPaymentTerms1(payment, idx) {
      let custom = this.localCustomPayments[idx];
      if (!custom.isEditingTerms1) custom.isEditingTerms1 = {};
      custom.isEditingTerms1[payment.id] = true;
      this.changeGrossPaymentCustom(payment.id, 'payment_terms1', idx);
    },
    editingCustomPaymentTerms2(payment, idx) {
      let custom = this.localCustomPayments[idx];
      if (!custom.isEditingTerms2) custom.isEditingTerms2 = {};
      custom.isEditingTerms2[payment.id] = true;
      this.changeGrossPaymentCustom(payment.id, 'payment_terms2', idx);
    },

    changeGrossPaymentCustom(id, item, idx) {
      let custom = this.localCustomPayments[idx];
      let payment = custom.terms.find(payment => payment.id === id);

      // ustawianie flagi na to, że payment się zmienił i ma pokazać button 'aktualizuj'
      this.$set(this.paymentChangedCustom, id, true);

      const vat = Number(custom.vat ?? 0);
      const net = Number(payment.net_payment_amount ?? 0);
      const gross = Number(payment.gross_payment_amount ?? 0);

      if (item === 'net_payment_amount') {
        payment.gross_payment_amount = Number((net * (1 + vat / 100)).toFixed(2));
      } else if (item === 'gross_payment_amount') {
        const denom = (1 + vat / 100) || 1;
        payment.net_payment_amount = Number((gross / denom).toFixed(2));
      } else if (item === 'currency' || item === 'exchange_rate' || item === 'vat') {
        // Przy zmianie VAT przelicz brutto od netto:
        payment.gross_payment_amount = Number((net * (1 + vat / 100)).toFixed(2));
      }
    },

    // Dodanie nowej mini-płatności do customPayment
    createCustomPaymentTerm(idx) {
      let custom = this.localCustomPayments[idx];
      custom.creatingPaymentTerms = !custom.creatingPaymentTerms;
    },

    removeCustomPaymentTerm(payment, idx) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie warunku płatności',
        html: 'Jesteś pewny że chcesz usunąć ten warunek płatność?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        denyButtonText: 'Nie',
        confirmButtonText: 'Tak',
      }).then((result) => {
        if (result.isConfirmed) {
          let custom = this.localCustomPayments[idx];
          let index = custom.terms.findIndex(p => p.id === payment.id);
          if (index !== -1) custom.terms.splice(index, 1);
          axios.delete(route('projects.show.custom-payments.destroyPaymentTerm', {customPayment: payment.id}))
              .then(response => {
                this.editPayments = response.data.payments;
                this.getPaidSum();
                Toast.fire({
                  toast: true,
                  icon: response.data.icon,
                  title: response.data.title,
                  html: response.data.message,
                  showClass: {popup: 'animate__animated animate__fadeInDown'},
                  hideClass: {popup: 'animate__animated animate__fadeOutUp'},
                  timer: 2500,
                })
              }).catch(error => {
            console.log(error);
            Toast.fire({
              toast: true,
              icon: 'error',
              title: 'Błąd',
              html: error.response.data.message,
              showClass: {popup: 'animate__animated animate__fadeInDown'},
              hideClass: {popup: 'animate__animated animate__fadeOutUp'},
              timer: 2500,
            })
            console.log(error);
          })
        }
      });
    },

    updateCustomPaymentTerms(paymentId, idx) {
      const custom = this.localCustomPayments[idx];
      let payment = custom.terms.find(payment => payment.id === paymentId);


      axios.post(route('projects.show.custom-payments.updatePaymentTerms', {
        payment: payment.id,
        custom_payment: custom.id
      }), {
        payment: payment,
        is_custom: true,
        custom_payment_parent_id: custom.id,
      }).then(response => {
        if (response.data.payments) {
          this.$delete(this.paymentChangedCustom, paymentId);
          delete custom.isEditingTerms1[paymentId];
          delete custom.isEditingTerms2[paymentId];
        }
        if (response.data.terms) {
          custom.terms = response.data.terms;
        }
        Toast.fire({
          toast: true,
          icon: response.data.icon,
          title: response.data.title,
          html: response.data.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        });
      }).catch(error => {
        Toast.fire({
          toast: true,
          icon: 'error',
          title: 'Błąd',
          html: error.response?.data?.message || error.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
        });
      });
    },

    toNum(v, def = 0) {
      const n = Number(v);
      return Number.isFinite(n) ? n : def;
    },

    formatMoney(value) {
      return new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
  },
}
</script>
